import React, { useEffect, useState } from 'react';
import Linechart from '../../components/LineChart/Linechart';
import StatCard from '../../components/StatCard/StatCard';
import { CiMoneyBill } from "react-icons/ci";
import { BsCreditCard } from "react-icons/bs";
import { HiUserPlus } from "react-icons/hi2";
import { FaBoxArchive } from "react-icons/fa6";
import axios from 'axios';
import { BASE_URL, USER_URL } from '../../constant/api';
import { Link } from 'react-router-dom';

function SellerHome() {

  const [username, setUsername] = useState("Guest");
 const [dashboard, setDashboard] = useState({});
  const [topProduct, setTopProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [chartdata,setChartData]=useState([])

  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem("user"));
    setUsername(savedUser?.user_name || "Guest");
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // const token = localStorage.getItem("token");
      // const headers = { Authorization: `Token ${token}` };

      try {
        const [
          dashboardResponse,
          topResponse,
          catResponse,
          chartResponse,
        ] = await Promise.all([
          
          USER_URL.get(`/orders/seller/dashboard/`),
          USER_URL.get(`/products/seller/top-selling/`),
          USER_URL.get(`/categories/`),
          USER_URL.get(`/orders/seller/revenue-sales/`),
        ]); 
        

       setDashboard(dashboardResponse.data.data)
        setTopProduct(topResponse.data.Data || []);
        setCategories(catResponse.data.Data || []);
        setChartData(chartResponse.data.Data)
       console.log(dashboardResponse.data.data);
       
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); console.log(dashboard);



  

  const getCategoryName = (id) => {
    return categories.find((cat) => cat.id === id)?.name || 'Unknown Category';
  };

  const statsData = [
    {
      title: 'Total Revenue',
      value: `₹${Math.floor(dashboard?.revenue?.total_revenue || 0)}`,
      change: `${dashboard?.revenue?.revenue_percentage_change || 0}`,
      bgColor: '#3250FF80',
      icon: <CiMoneyBill size={24} />,
      link: "/seller/statements",
    },
    {
      title: 'Total Orders',
      value: `${dashboard?.orders?.total_orders || 0}`,
      change: `${dashboard?.orders?.order_percentage_change || 0}`,
      bgColor: '#F9C80E80',
      icon: <BsCreditCard size={24} />,
      link: "/seller/orders/view_orders",
    },
    {
      title: 'Total Customers',
      value: `${dashboard?.customers?.total_customers || 0}`,
      change: `${dashboard?.customers?.customer_percentage_change || 0}`,
      bgColor: '#22CAAD80',
      icon: <HiUserPlus size={24} />,
    },
    {
      title: 'Total Products',
      value: `${dashboard?.products?.total_products || 0}`,
      change: `${dashboard?.products?.product_percentage_change || 0}`,
      bgColor: '#22CAAD80',
      icon: <FaBoxArchive size={24} />,
      link: "/seller/products/view_products",
    },
    {
      title: "Today's Sales",
      value: `${dashboard?.sales?.today_sales || 0}`,
      change: `${dashboard?.sales?.today_sales_percentage_change || 0}`,
      bgColor: '#4E568380',
      icon: <BsCreditCard size={24} />,
      link: "/seller/orders/view_orders",
    },
    {
      title: "Total Sales",
      value: `${dashboard?.sales?.total_sales || 0}`,
      change: `${dashboard?.sales?.total_sales_percentage_change || 0}`,
      bgColor: '#4D9D8F80',
      icon: <BsCreditCard size={24} />,
      link: "/seller/sales/view_sales",
    },
    {
      title: "Total Stocks",
      value: `${dashboard?.stock?.total_stock || 0}`,
      change: `${dashboard?.stock?.stock_percentage_change || 0}`,
      bgColor: '#1F295E80',
      icon: <BsCreditCard size={24} />,
      link: "/seller/stocks",
    },
    {
      title: "New Products",
      value: `${dashboard?.products?.new_products || 0}`,
      change: `${dashboard?.products?.new_products_percentage_change || 0}`,
      bgColor: '#05BF0233',
      icon: <FaBoxArchive size={24} />,
      link: "/seller/products/view_products",
    },
  ];
  

  const topData = topProduct.map((product) => ({
    id:product.id,
    title: product.name,
    category: getCategoryName(product.category),
    imageSrc: product.product_images[0]?.image || '',
  }));
console.log(topData);

 

  const ProductList = ({id, title, category, imageSrc }) => (
    <Link to={`/seller/products/view/${id}`}>
    <div className="flex items-center space-x-4 mb-2  p-2 bg-gray-100 rounded-md shadow-sm h-14">
      <img src={imageSrc} alt={title} className="w-8 h-8 object-cover rounded-lg" />
      <div className="text-gray-700">
        <div className="text-xs font-semibold">{title}</div>
        <div className="text-xs text-gray-500">Category: {category}</div>
      </div>
    </div>
    </Link>
  );

  return (
    <div className="space-y-8 p-2 min-h-screen">
      <h5 style={{ fontSize: "30px" }}> Welcome <span>{username},</span></h5>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 ">
        {statsData.map((stat, index) => (
          <StatCard
            key={index}
            title={stat.title}
            value={stat.value}
            change={stat.change}
            bgColor={stat.bgColor}
            icon={stat.icon}
            link={stat.link}
          />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
        <Linechart data={chartdata} />
        <div className="space-y-4 ">
          <div className="p-4 bg-white rounded-lg shadow-md flex flex-col  sm:h-[400px] h-[350px]">
            <h3 className="text-xs font-semibold mb-4  text-gray-700">Top Selling Products</h3>
            <div className="space-y-4 overflow-y-auto" style={{maxHeight: "calc(100%)",}}> 
              {topData.map((stat, index) => (
                <ProductList
                  key={index}
                  id={stat.id}
                  title={stat.title}
                  category={stat.category}
                  imageSrc={stat.imageSrc}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SellerHome;




